import 'gridstrap/svg-symbols/phone.svg?sprite';
import './lady.jpg';
import './hover-cta.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSHoverCta } from './hover-cta';

components.register({
	selector: '.gs-HoverCta',
	controller: GSHoverCta
});
